module.exports = __webpack_public_path__ + "static/media/administerit.c61085d2.png";